import { Editor } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { Bold } from './Bold';
import { Code } from './Code';
import { Highlight } from './Highlight';
import { Italic } from './Italic';
import { Link } from './Link';
import { Subscript } from './Subscript';
import { Superscript } from './Superscript';
import { Underline } from './Underline';

import classes from './InlineTools.module.scss';

export interface InlineToolsProps {
  editor: Editor;
  isShortPost?: boolean;
}

export const InlineTools: FunctionComponent<InlineToolsProps> = ({ editor, isShortPost }) => {
  return (
    <div className={classes['inline-tools']}>
      <Bold editor={editor} />
      <Italic editor={editor} />
      <Underline editor={editor} />
      <Link editor={editor} />

      {!isShortPost && (
        <>
          <Highlight editor={editor} />
          <Code editor={editor} />
          <Subscript editor={editor} />
          <Superscript editor={editor} />
        </>
      )}
    </div>
  );
};
